import * as api from "../../constants/api";
import * as axiosUtils from "../../utils/axiosUtils";
import { toIsoString } from "../../utils/date";

export const actionTypeAntallIleggelserPerIleggelsetype =
  "ANTALL_ILEGGELSER_PER_ILEGGELSETYPE";

export const getAntallIleggelserPerIleggelsetype = (params) => {
  return axiosUtils.GetAllWithParams(
    api.GET_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_URL,
    {
      fraDato: toIsoString(params.fraDato),
      tilDato: toIsoString(params.tilDato),
    },
    actionTypeAntallIleggelserPerIleggelsetype,
  );
};
